import { Injectable } from "@angular/core";
import { BenefitConfiguration } from "src/app/ui/models/domains/pbm/Benefit/benefit-configuration";
import { AbstractParser } from "../../parser";

@Injectable()
export class BenefitConfigurationParser extends AbstractParser<BenefitConfiguration> {
  parse(payload: any): BenefitConfiguration {
    const benefitConfiguration = new BenefitConfiguration();
    benefitConfiguration.setId(payload.Id);
    benefitConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    return benefitConfiguration;
  }
}
